
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";
import { SearchTextField } from "../../components/SearchTextField";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { ActualizarPuesto, AgregarPuesto, Puestos } from "../../connections/catalogos/PuestoConnection";

import { PuestoProps } from "../../interfaces/catalogos/PuestoInterface";

type OptionType = 'Agregar' | 'Editar';

export const PuestoPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [PuestoArray, setPuestoArray] = useState<PuestoProps[]>([]);

    const [openModal, setOpenModal] = useState<boolean>(false);

    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);

    const [idPuesto, setIdPuesto] = useState(0);
    const [descripcion, setDescripcion] = useState('');
    const [referencia, setReferencia] = useState('');

    const [opcion, setOpcion] = useState<OptionType>('Agregar');

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(5);

    const { filtro, setFiltro, dataFiltrada } = useFilter( PuestoArray, ( item, filtro ) => item.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const PuestoSelected = PuestoArray.find((elem) => elem.idPuesto === id);

        if (PuestoSelected) {

            await ActualizarPuesto({ ...PuestoSelected, activo: checked }).then(resp => {

                if (resp.idPuesto) {

                    var newArray = PuestoArray.map((elem) => {

                        if (elem.idPuesto === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setPuestoArray(newArray);
                    
                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                }

            });
        }

    }

    const AgregarRegistro = () => {

        setDescripcion('');
        setReferencia('');
        setIdPuesto(0);
        
        setOpcion('Agregar');
        setOpenModal(true);
    }

    const EditarRegistro = ({ idPuesto, referencia, descripcion }: PuestoProps) => {

        setDescripcion( descripcion );
        setReferencia( referencia.toString() ?? '' );
        setIdPuesto( idPuesto );

        setOpcion('Editar');
        setOpenModal(true);
    }
 
    const handleGuardar = async () => {

        setLoading( true )

        if ( opcion === 'Editar' ) {

            const Puesto = PuestoArray.find( (row ) => row.idPuesto === idPuesto );

            const params: PuestoProps = {
                idPuesto: idPuesto,         
                referencia: referencia === '' ? 0 : parseInt(referencia),
                descripcion: descripcion.trim(),
                activo: Puesto?.activo ?? false,
            };

            await ActualizarPuesto( params ).then( resp => {

                if( resp ) {

                    setTimeout(() => {

                        const newRows = PuestoArray.map( ( row ) => {

                            if ( row.idPuesto === idPuesto ) {
                                row.referencia = resp.referencia;
                                row.descripcion = descripcion;                              
                                return row;
                            }
                            
                            return row;                            
                        });

                        setPuestoArray(newRows);

                        setLoading(false);
                        setOpenModal(false);
                    
                        dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                    }, 400);

                }

            });
        }
        else if ( opcion === "Agregar" ) {

            const params: PuestoProps = {
                idPuesto: 0,
                referencia: referencia === '' ? 0 : parseInt(referencia),
                descripcion: descripcion.trim(),
                activo: true,
            };

            await AgregarPuesto( params ).then( resp => {

                if ( resp ) {

                    setTimeout(() => {

                        setPuestoArray([ ...PuestoArray, resp ]);

                        setLoading( false );
                        setOpenModal( false );

                        dispatch( openSnackbar({ message: 'Se agregó el puesto correctamente', variant: 'success' })); 

                    }, 400);

                }

            });
        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData(true);
            setPuestoArray([]);

            await Puestos().then(resp => {

                setTimeout(() => {

                    setPuestoArray(resp);
                    setLoadingData(false);

                }, 700);

            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Puesto' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ md: 6, xs: 12 }} textAlign={'start'}>

                    <Button startIcon={<UndoIcon />} color="secondary" variant="text" sx={{ mt: 1 }} onClick={() => navigate('/')}>
                        Regresar
                    </Button>

                </Grid>

                <Grid size={{ md: 6, xs: 12 }} textAlign={'end'}>

                    <Button
                        type="button"
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={loadingData}
                        onClick={ AgregarRegistro }
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }}>

                    <SearchTextField
                        value={ filtro }
                        label="Buscar por descripción"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '50%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', textAlign: 'center' }}> Referencia SAJI </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                :
                                    dataFiltrada
                            )
                                .map(({ idPuesto, descripcion, activo, referencia }) => (

                                    <TableRow key={idPuesto} >

                                        <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            {idPuesto}
                                        </TableCell>

                                        <TableCell>
                                            {descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            { referencia ? <> ({ referencia }) </> : '' }
                                        </TableCell>                                                        

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={activo}
                                                onChange={(e) => handleChangeChecked(e.target.checked, idPuesto)}
                                            />
                                    
                                            <IconButton
                                                color="primary"
                                                aria-label="edit"
                                                component="span"
                                                onClick={ () =>  EditarRegistro({ idPuesto, referencia, descripcion, activo }) }
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center">

                                            <CircularProgress size={32} />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={2} sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: {dataFiltrada.length}
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                    colSpan={8}
                                    count={dataFiltrada.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}

                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}

                                    ActionsComponent={TablePaginationActions}

                                    labelRowsPerPage="Filas por página"
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog 
                maxWidth='sm' 
                open={openModal} 
                fullWidth={true}
            >

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={3} sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                fullWidth
                                label={'Referencia en SAJI'}
                                variant="outlined"                     
                                type='number'
                                value={ referencia }
                                onChange={(e) => { setReferencia(e.target.value) }}
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}        
                            />
                        </Grid>
                        
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                label={'Descripción'}
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)}
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}        
                            />
                        </Grid>
                        
                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button disabled={ loading } onClick={ () => setOpenModal( false ) }> Cancelar </Button>
                    <Button 
                        variant='contained' 
                        loading={ loading } 
                        disabled={ descripcion === '' || ( referencia === '0' || referencia === '' ) } 
                        onClick={ handleGuardar } 
                    > 
                        Guardar 
                    </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}